export { default } from './DailyProfilesTable';
